/* eslint-disable no-restricted-imports, @fullscript/cross-reference */
import * as remix from "@remix-run/react";
import * as router from "react-router-dom";

/**
 * A NavLink component wrapping NavLink from Remix and react-router-dom
 * It can be used in interchangeably in a Remix or react-router-dom based SPA and work as expected
 * Means that devs don't need to worry about where an app is running and what API to use
 */
const NavLink = (props: router.NavLinkProps & React.RefAttributes<HTMLAnchorElement>) => {
  let isRouter = true;

  try {
    router.useLocation();
  } catch (e) {
    isRouter = false;
  }

  if (isRouter) {
    return <router.NavLink {...props} />;
  }

  return <remix.NavLink {...props} />;
};

export { NavLink };
